import { useQuery } from '@apollo/client';
// Api
import { GET_TICKET_EVENT_SCHEDULE_DEFAULTS } from 'api/ticketEvents/queries';
// Types
import { GetTicketEventScheduleDefaults } from 'api/ticketEvents/types/GetTicketEventScheduleDefaults';
// Helpers
import {
  getSalesCloseOptions,
  SalesCloseOption,
  secondsToHours,
} from 'helpers/ticketEvents';
// Ui
import Select from 'ui3/Select/Select';

type SalesCloseSelectProps = {
  /** Hours after the start; null shows the admin's default, which the event keeps unless another is picked. */
  value: number | null;
  onChange: (hours: number) => void;
};

const SalesCloseSelect = ({
  value,
  onChange,
}: SalesCloseSelectProps): JSX.Element => {
  const { data } = useQuery<GetTicketEventScheduleDefaults>(
    GET_TICKET_EVENT_SCHEDULE_DEFAULTS
  );
  const defaults = data?.ticketEventScheduleDefaults;
  const defaultHours = defaults
    ? secondsToHours(defaults.salesCloseAfterStartSeconds)
    : null;
  const options =
    defaults && defaultHours !== null
      ? getSalesCloseOptions({
          defaultHours,
          maxHours: secondsToHours(defaults.maxSalesCloseAfterStartSeconds),
          currentHours: value,
        })
      : [];
  const selectedHours = value ?? defaultHours;

  return (
    <Select
      label="Close Ticket Sales"
      placeholder="Select"
      options={options}
      getOptionLabel={(option: SalesCloseOption) => option.label}
      getOptionValue={(option: SalesCloseOption) => `${option.value}`}
      inputId="salesCloseHours"
      value={options.find((option) => option.value === selectedHours)}
      onChange={(option: SalesCloseOption) => onChange(option.value)}
    />
  );
};

export default SalesCloseSelect;
